export const animateCSS = (element, animation, prefix = 'animate__') =>
    // We create a Promise and return it
    new Promise((resolve, reject) => {
        const animationName = `${prefix}${animation}`;
        const node = document.querySelectorAll(element);
        if (node && node.length > 0) {
            [...node].map(item => {
                console.log('item', item)
                item.classList.add(`${prefix}animated`, animationName);
                item.style.visibility = 'visible'
            })
        }
        // node.classList.add(`${prefix}animated`, animationName);
        // node.style.visibility= 'visible'

        // When the animation ends, we clean the classes and resolve the Promise
        function handleAnimationEnd(event) {
            if (node && node.length > 0) {
                [...node].map(item => {
                    event.stopPropagation();
                    item.classList.remove(`${prefix}animated`, animationName);
                    resolve('Animation ended');
                })
            }
            /* event.stopPropagation();
            node.classList.remove(`${prefix}animated`, animationName);
            resolve('Animation ended'); */
        }
        if (node && node.length > 0) {
            [...node].map(item => {
                item.addEventListener('animationend', handleAnimationEnd, {
                    once: true
                });
            })
        }

        /* node.addEventListener('animationend', handleAnimationEnd, {
            once: true
        }); */
    });

export const changeText = (value) => {
    if (value) {
        return value.replace(/\n/g, '<br/>') // /\r\n/g
    }
}

export const judgeWindow = () => {
    let windowW = document.body.clientWidth
    if (windowW < 768) {
        return true
    }
    return false

}

export function isCN() {
    if (navigator.language.indexOf("zh") == 0) {
        return true
    }
    return false
}